import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import getOrders from './getOrders.graphql';
import s from './OrderDetailsContainer.css';
import OrderDetails from '../../../components/Shop/OrderDetails/OrderDetails';
import Loader from '../../../components/Common/Loader';

class OrderDetailsContainer extends React.Component {
    static defaultProps = {
        orderData: {
            loading: true,
            getOrders: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refetchTime !== this.props.refetchTime && this.props.refetchTime) {
            if (this.props.orderData && !this.props.orderData.loading) {
                this.props.orderData.refetch({ id: this.props.bookingId });
            }
        }
    }

    render() {
        const { type, bookingId, orderData, orderData: { loading, getOrders } } = this.props;

        return (
            <>
                {/* <div className={s.container}> */}
                {
                    !loading && orderData && <OrderDetails
                        type={type}
                        bookingId={bookingId}
                        data={getOrders && getOrders.result}
                    />
                }
                {
                    (loading || (loading && !orderData)) && <Loader type="text" />
                }
                {/* </div> */}
            </>
        );
    }
}

const mapState = (state) => ({
    refetchTime: state.orderData && state.orderData.refetchTime
});

export default compose(
    withStyles(s),
    connect(mapState),
    graphql(getOrders, {
        name: 'orderData',
        options: (props) => ({
            variables: {
                id: props.bookingId
            },
            fetchPolicy: 'network-only',
            ssr: true
        })
    })
)(OrderDetailsContainer);
// export default withStyles(s)(OrderDetailsContainer);
